import { render, staticRenderFns } from "./JoinPage.vue?vue&type=template&id=4bea8b49&scoped=true&"
import script from "./JoinPage.vue?vue&type=script&lang=js&"
export * from "./JoinPage.vue?vue&type=script&lang=js&"
import style0 from "./JoinPage.vue?vue&type=style&index=0&id=4bea8b49&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bea8b49",
  null
  
)

export default component.exports